import { EventEmitter, Injectable, Output } from '@angular/core';
import { MarketingFilter } from '../../../shared/models/metrics/marketingFilter';
import { RolType } from '../../../shared/models/types/rol.types';
import { AuthService } from '../../../shared/services/security/auth.service';

@Injectable()
export class MarketingComunicationService {

  @Output() readonly filter: EventEmitter<any> = new EventEmitter();
  rolType: RolType = new RolType();

  public constructor(private readonly authService: AuthService) {
  }

  applyFilter(filter: MarketingFilter, filterForTable: any): void {
    this.filter.emit({ filter, filterForTable });
  }

}
